import React, { ReactElement } from "react";
import Image from "next/image";
import styles from "./styles.module.scss";
import SellingBox from "../sellingBox";
import { useDomainContext } from "@hooks/useDomainContext";

export default function CategoryMainBanner(): ReactElement {
    const { formattedTitle, category, visitDetails } = useDomainContext();

    return (
        <>
            <div className={styles["main-banner"]}>
                <main
                    className={`${styles["main-banner-container"]} max-w-7xl mx-auto block px-4vw lg:px-4`}
                >
                    <div className={styles["content"]}>
                        <h1 className="capitalize">
                            {formattedTitle ? (
                                formattedTitle
                            ) : (
                                <>Save Big on {category?.name} Now</>
                            )}
                        </h1>
                        <p className="text-xs lg:text-base font-light mt-3 capitalize">
                            Submit the Zip Code Below to Compare{" "}
                            {category?.name} Companies Right Now. Act Now:
                        </p>
                        <div className={styles["selling-box"]}>
                            <SellingBox />
                        </div>
                        {visitDetails?.region && (
                            <div className={styles["city-best"]}>
                                {visitDetails.region} Best {category?.name}{" "}
                                Companies
                            </div>
                        )}
                    </div>
                </main>
                <div className={`${styles["image"]} `}>
                    <Image
                        src="/insurancesupersaver/assets/images/background-imageOpt.jpg"
                        className={styles["background-img"]}
                        alt="auto-banner"
                        layout="intrinsic"
                        priority
                        width={1500}
                        height={1730}
                    />
                </div>
            </div>
        </>
    );
}
